/*
    sidebar component should be a component usable for all main views
*/
import React, {useState} from 'react';
import { rbac } from '../index';
import t from '../../../helpers/t';
import { $} from "../../../../../vendor";
import SidebarFilter from "../../../components/SidebarFilter";
import {Biscuit, getAllUrlParams} from "../../../../utils";
import NewContingentButton from './behaviors/NewContingentButton';

const ContingentsSidebar = (props) => {
    const {
        initialized, setFilter, filter, filterChangedHandle, sort, setSort, setResetFilter, resourcetypes, locations, onLocationQueryHandle, setAdd
    } = props;
    const currentUrl = new URL(window.location.href)
    const searchParams = currentUrl.searchParams;
    const allUrlParams = getAllUrlParams(window.location.href)
    allUrlParams?.location_name !== undefined && delete allUrlParams.location_name;
    allUrlParams?.resourcetype_id !== undefined && delete allUrlParams.resourcetype_id;
    allUrlParams?.path !== undefined && delete allUrlParams.path;
    const cleanState = {locationFilter:false,typeFilter:false};
    const [usedFilterCount,setUsedFilterCount] = useState({locationFilter:allUrlParams?.location_id !== undefined ? true : false,typeFilter:allUrlParams?.resourcetype_id !== undefined ? true : false});
    const [filterCount, setFilterCount] = useState(Object.keys(allUrlParams).length > 0 ? Object.keys(allUrlParams).length : 0);
    const [typesFilter, setTypesFilter] = useState(searchParams.get("resourcetype_id") !== null ? searchParams.get("resourcetype_id") : 'all');
   const [locationFilter, setLocationFilter] = useState(searchParams.get("location_id") !== null ? {id: searchParams.get("location_id"), name: searchParams.get("location_name")} : null);
    const [initialState, setInitialState] = useState(initialized);
    const [typeFilter, setTypeFilter] = useState([
        {name: t('all'), value: 'all', dataKey: 'state_all'}
    ]);
    const onToggleLeftBar = (ev) => {

        $('#inb-c-sidebar').toggleClass('open');
        $('html,body').scrollTop(0);
    };
    const onFilterCountChangeHandle = (value) => {
        let clone = {...value};
        let count = 0;
        for (const [type, val] of Object.entries(clone)) {
            if(val){
                count++;
            }
        }
        if(count < 1){
            count = 0;
            $('#inb-selected-filters').addClass('hidden');
        } else {
            $('#inb-selected-filters').removeClass('hidden');
        }
        setFilterCount(count);

    };

    const resetFilter = (disp = true) =>
    {
        let clone = {
            find: 'full'
        };
        setTypesFilter('all');
        setLocationFilter('all');
        setFilterCount(0);
        setFilter(clone);
        setUsedFilterCount(cleanState);
        onFilterCountChangeHandle(cleanState);
        if(disp) {
            filterChangedHandle(clone, {
                sort: "name",
                direction: "asc"
            });
        } else {
            setFilter(clone);
        }
        const newRelativePathQuery = window.location.pathname;
        history.pushState(null, "", newRelativePathQuery);
    }

    const addContingent = () => {
        setAdd(true);
    }

    const onTypesFilterChange = (val) => {
        setTypesFilter(val);                  // set status filter
        let clone = {...filter};
        let clone2 = {...usedFilterCount};           // get current filter settings (all filter)

        if (val !== 'all') {
            // add status filter to global filter
            clone.resourcetype_id = val;
            clone2.typeFilter = true;
            searchParams.set('resourcetype_id', val);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else {
            // remove status filter from global filter
            delete clone['resourcetype_id'];
            clone2.typeFilter = false;
            searchParams.delete('resourcetype_id');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }

        setUsedFilterCount(clone2);
        setFilter(clone);
        onFilterCountChangeHandle(clone2);
        filterChangedHandle(clone);
    };

    const onLocationFilterChange = (locationId, locationName, fetch = true) => {
        const location = {name: locationName, id: locationId};
        setLocationFilter(null);                  // set status filter
        let clone = {...filter};
        let clone2 = {...usedFilterCount};           // get current filter settings (all filter)

        if (typeof locationId !== 'undefined' && locationId !== null) {
            // add status filter to global filter
            clone.location_id = location.id;
            clone2.locationFilter = true;
            setLocationFilter(location);
            searchParams.set('location_id', location.id);
            searchParams.set('location_name', location.name);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else {
            // remove status filter from global filter
            delete clone['location_id'];
            clone2.locationFilter = false;
            setLocationFilter(null);
            searchParams.delete('location_id');
            searchParams.delete('location_name');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        setUsedFilterCount(clone2);
        setFilter(clone);
        onFilterCountChangeHandle(clone2);
        filterChangedHandle(clone);                 // cloned object must be used because global filter is not yet updated
    };


    const waitForInitialState = () => {
        if(initialState === true || typeFilter.length > 1) return;
        setTimeout(function () {
            if(resourcetypes.length > 0){
                let clone = [...typeFilter];
                resourcetypes.map(resourcetype => {
                    clone.push({
                        name: resourcetype.name,
                        value: resourcetype.id.toString(),
                        dataKey: 'state_' + resourcetype.name
                    });
                });
                setTypeFilter(clone);
                setInitialState(true);
            }
        },100);
    }
    if(!initialized){
        waitForInitialState();
    }
    return (
        <aside
            id="inb-c-sidebar"
            className="contingent-sidebar"
            style={{float:'left'}}>
            <header className="inb-c-left-bar__title sticky-top">
                <h1 className="inb-page-title">
                {t("contingents",null,"capital")}
                </h1>
            </header>
            {initialState && <> <aside id="inb-selected-filters">
                {filterCount > 0 && <ul>
                    <p>
                        <i className="fi fi-filter"> </i>
                        <span id="inb-selected-filters__count">
                               {" " + filterCount}
                             </span>

                        {" " + t('filter_selected')}
                        <a href="#"
                           id="inb-selected-filters__unset"
                           className="unset-filter"
                           title={t('unselect_all_filter')} onClick={(e) => {
                            resetFilter(e)
                        }}>
                            x
                        </a>
                    </p>
                </ul>}
            </aside>
            <div className="sticky-top-filter">
            {typeFilter.length > 1 && <SidebarFilter
                id="inb-c-left-bar-flist--contingent-resourcetypes"
                heading={t('resourcetype',null,'plural')}
                type="list"
                data= {typeFilter}
                dataKey="value"
                selected={typesFilter.toString()}
                onChangeHandle={onTypesFilterChange}/>}
                <hr />

            {/*  <ul id="inb-c-left-bar-flist--contingent-locations"
                className="inb-vert-list">
                <span className="inb-list-title">
                    {t('location',null,'capital')}
                </span>
                <select
                    className="inbooma-select-box__input"
                    name="locations"
                    onChange={(e) => onLocationFilterChange(e)}
                    value={locationFilter}
                    placeholder={t('select_${a}',{a:t('location')})}>
                    {locations.map(location => {
                        return(
                            <>
                                <option key={location.id} value={location.id}>{location.name}</option>
                            </>
                        )
                    })}
                </select>
                {locationFilter !== undefined && locationFilter !== null &&
                    <a href="#" className="inbooma-select-box__reset" onClick={() => onLocationFilterChange('all')} style={{float:'unset', paddingLeft:'15px'}}>
                        x
                    </a>
                }
            </ul>*/}
                <SidebarFilter
                id="inb-c-left-bar-flist--contingents-location"
                heading={t('location',null,'capital')}
                type="select2"
                data={locations}
                dataKey="id"
                nameAttribute="name"
                onQueryHandle={onLocationQueryHandle}
                onChangeHandle={onLocationFilterChange}
                value={locationFilter !== null?locationFilter:null}
                placeholder={'- ' + t('all', null, 'capital') + ' -'}
                //selected={selectedBeginLocation}
                />
            </div>
            </>
            }
            {rbac.hasPermission('write') && Biscuit.get('user.role') !== 'manager' &&
                <footer
                 className="inb-c-left-bar__footer small-only-float-container"
                 data-inb-action-link="write">
                     <a href="#"
                        id="toggle-left-bar"
                        className="button secondary show-for-small-only" onClick={(e) => onToggleLeftBar(e)}>
                            <i className="fi fi-filter"> </i>
                            <span className="show-for-sr">{t('open_filter_menu')}</span>
                    </a>
                    <NewContingentButton
                        addContingent={addContingent}
                    />
                </footer>
            }
        </aside>
    );
};

export default ContingentsSidebar;